import React from "react";
import PropTypes from "prop-types";
import {
    FormGroup,
    Form,
    Col,
    ControlLabel,
    Checkbox,
} from "react-bootstrap";
import NumberFormat from "react-number-format";
import isNumber from "lodash/isNumber";
import { TemplateTypeSelectDropdown } from "./template-type-select-dropdown";

import UserDataInjector from "../core/user/user-data";

export class PageTemplateSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pagetemplateStatus: props.template.active,
            selectedTemplateType: props.template.templateTypeId,
            animationClass: "",
            price: props.template.price,
        };
        this.changeStatus = this.changeStatus.bind(this);
        this.update = this.update.bind(this);
        this.onDropdownChange = this.onDropdownChange.bind(this);
        this.priceInput = null;
    }

    changeStatus(e) {
        this.setState({ pagetemplateStatus: e.target.checked });
    }

    onDropdownChange(selectedTemplateType) {
        this.setState({ selectedTemplateType });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ pagetemplateStatus: nextProps.template.active, selectedTemplateType: nextProps.template.templateTypeId });
    }

    componentWillMount() {
        setTimeout(() => {
            this.setState({
                animationClass: "slideInRight active"
            });
        }, 100);
    }

    update() {
        const {
            template,
        } = this.props;
        const {
            pagetemplateStatus,
            selectedTemplateType,
            price,
        } = this.state;
        let templateUpdateValues = {
            referenceId: template.referenceId,
            active: pagetemplateStatus,
            templateType: selectedTemplateType.templateTypeId,
        };
        if (isNumber(price)) {
            templateUpdateValues.price = price;
        }
        this.props.updateStatus(templateUpdateValues);
    }

    render() {
        const {
            closeAddNewTemplate,
            template,
        } = this.props;
        const {
            animationClass,
        } = this.state;
        return (
            <div className={`page-template-settings-section rightPanel clearfix ${animationClass}`} id="editrightPanel">
                <div className="pointer text-right page-template-close-icon" onClick={closeAddNewTemplate}>
                    <i className="fa fa-close" aria-hidden="true" />
                </div>
                <div className="panel-content full-width p-md">
                    <h2 className="m-b-md">Edit Template</h2>
                    <Form horizontal>
                        <FormGroup controlId="formInputStatus">
                            <Col componentClass={ControlLabel} sm={4}>
                                Active
                            </Col>
                            <Col sm={8}>
                                <Checkbox id="activepageTemplate"
                                    checked={this.state.pagetemplateStatus}
                                    onChange={this.changeStatus}
                                />
                            </Col>
                        </FormGroup>
                        <UserDataInjector>
                            {
                                (userData) => {
                                    if (userData.isDesignerUser) {
                                        return (
                                            <FormGroup controlId="formInputPrice">
                                                <Col componentClass={ControlLabel} sm={4}>
                                                    Price
                                                </Col>
                                                <Col sm={8}>
                                                    <NumberFormat
                                                        type="text"
                                                        getInputRef = {(el) => this.priceInput = el}
                                                        className="form-control"
                                                        prefix={"$"}
                                                        defaultValue={template.price}
                                                        decimalScale={2}
                                                        fixedDecimalScale
                                                        onValueChange={(values) => {
                                                            const { value } = values;
                                                            this.setState({ price: +value });
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        );
                                    }
                                    return null;
                                }
                            }
                        </UserDataInjector>
                        <FormGroup controlId="formSelectTemplateType">
                            <Col componentClass={ControlLabel} sm={4}>
                                Page Type
                            </Col>
                            <Col sm={8}>
                                <TemplateTypeSelectDropdown
                                    initialTemplateTypeId={template && template.templateTypeId}
                                    onDropdownChange={this.onDropdownChange}
                                />
                            </Col>
                        </FormGroup>
                        <div className="text-right">
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={this.update}
                            >
                                Save
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

PageTemplateSettings.propTypes = {
    templateTypeMap: PropTypes.array,
    closeAddNewTemplate: PropTypes.func,
    fromSettings: PropTypes.bool,
    template: PropTypes.object,
    updateStatus: PropTypes.func
};